import type { WeeklyScheduleSchema } from '@libs/data-access/entities'
import type { ShiftRQSchema } from '@libs/data-access/queries'
import { Select, useSafeRouterSearchParams } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import type { FC } from 'react'
import React from 'react'
import { Controller, type Control } from 'react-hook-form'

import { useGetLockedDays } from '../../hooks'
import { getIsoDaysInWeek } from '../../utils'

import { computeDisabledDays } from './utils/computeDisabledDays'

type Props = {
  weeklyschedule: WeeklyScheduleSchema
  control: Control
  errors: any
  shift: ShiftRQSchema
  setValue: Function
}

export const UpdateDayField: FC<Props> = ({
  weeklyschedule,
  control,
  errors,
  shift,
  setValue
}) => {
  const { t, tDates } = usePlanningFormTranslation()
  const [searchParams] = useSafeRouterSearchParams()
  const days = getIsoDaysInWeek(searchParams.date)
  const { lockedDays } = useGetLockedDays(days)

  const disableDays = computeDisabledDays({
    days,
    weeklyschedule,
    lockedDays
  })

  const options = days.map(day => ({
    value: day,
    label: tDates('dates.literalDate', { date: day }),
    disabled: disableDays[day]
  }))

  const handleChange = (value: string) => {
    setValue(
      'update_day',
      options.find(x => x.value === value)
    )
  }

  return (
    <Controller
      name='update_day'
      control={control}
      render={({ field: { value } }) => (
        <Select
          searchable
          fillWidth
          closeOnOptionClick
          className='mb-2'
          options={options}
          dropdownHeight='m'
          dropdownWidth='target'
          onChange={handleChange}
          value={value?.value}
          disabled={Boolean(shift.locked_at)}
          errorMessage={formatErrors({
            inputName: 'update_day',
            errors
          })}
          placeholder={t('component.fieldUpdateDay.placeholder')}
          label={t('component.fieldUpdateDay.title')}
        />
      )}
    />
  )
}
